<template>
  <div class="w-full md:w-2/3 mx-auto">
    <ProgressionBar v-if="anyActivePlan" :max="stepComponents.length" :value="step" />
    <component
      v-for="(stepComponent, index) in stepComponents"
      :key="index"
      :is="stepComponent"
      v-show="step === index + 1"
      :componentStep="index + 1"
      :currentStep="step"
      @next="nextStep"
      @previous="step--"
    />
  </div>
</template>

<script>
import PlanSaleSelectionStep from "@/components/claim/form/steps/PlanSaleSelectionStep.vue";
import ProductSelectionStep from "@/components/claim/form/steps/ProductSelectionStep.vue";
import ManualClaimProductCreationStep from "@/components/claim/form/steps/ManualClaimProductCreationStep.vue";
import {
  ProgressionBar,
  PersonalInformationStep,
  AddressStep,
  OccurrenceDateStep,
  OccurrencePlaceStep,
  CoverageStep,
  TheftTypeStep,
  BreakdownQuestionStep,
  BreakdownImpactOrDropStep,
  DescriptionStep,
  ComplaintsReceiptStep,
  ProductInvoiceStep,
  AntiTheftDeviceInvoiceStep,
  ProductPhotosStep,
  MarkingNumberStep,
  MarkingNumberPhotosStep,
  FraudulentSimUseStep,
  FraudulentSimUseProofStep,
  InvoiceHolderStep,
  InvoiceHolderProofStep,
  HomeInsuranceCertificateStep,
  DeclarationCompletedStep,
} from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    ProgressionBar,
    PlanSaleSelectionStep,
    ManualClaimProductCreationStep,
    ProductSelectionStep,
    PersonalInformationStep,
    AddressStep,
    OccurrenceDateStep,
    OccurrencePlaceStep,
    CoverageStep,
    TheftTypeStep,
    BreakdownQuestionStep,
    BreakdownImpactOrDropStep,
    DescriptionStep,
    ComplaintsReceiptStep,
    ProductInvoiceStep,
    AntiTheftDeviceInvoiceStep,
    ProductPhotosStep,
    MarkingNumberStep,
    MarkingNumberPhotosStep,
    FraudulentSimUseStep,
    FraudulentSimUseProofStep,
    InvoiceHolderStep,
    InvoiceHolderProofStep,
    HomeInsuranceCertificateStep,
    DeclarationCompletedStep,
  },
  data() {
    return {
      step: 1,
      stepComponents: [
        PlanSaleSelectionStep,
        ManualClaimProductCreationStep,
        ProductSelectionStep,
        PersonalInformationStep,
        AddressStep,
        OccurrenceDateStep,
        OccurrencePlaceStep,
        CoverageStep,
        TheftTypeStep,
        BreakdownQuestionStep,
        BreakdownImpactOrDropStep,
        DescriptionStep,
        ComplaintsReceiptStep,
        ProductInvoiceStep,
        InvoiceHolderStep,
        InvoiceHolderProofStep,
        AntiTheftDeviceInvoiceStep,
        ProductPhotosStep,
        MarkingNumberStep,
        MarkingNumberPhotosStep,
        FraudulentSimUseStep,
        FraudulentSimUseProofStep,
        HomeInsuranceCertificateStep,
        DeclarationCompletedStep,
      ],
    };
  },
  computed: {
    ...mapState("customer", ["plans"]),
    ...mapGetters("planSales", ["isActive"]),

    anyActivePlan() {
      return this.plans?.filter((plan) => this.isActive(plan)).length > 0;
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    async nextStep() {
      this.step++;
      if (this.step > this.stepComponents.length) await this.declarationCompleted();
    },
    async declarationCompleted() {
      await this.notify({
        category: "simple",
        type: "success",
        title: "Your claim has been submitted!",
        text: "It's being reviewed by our team and you will hear back from a representative within 1-2 business days.",
      });
      this.$router.push("/claims");
    },
  },
};
</script>
